import React from 'react';

import useWizardContext from '@swf/core/hooks/useWizardContext';

import type { PreCashinInfo } from '../../../../../../../types/Cashier';

import DefaultTicketsBonus from './components/DefaultTicketsBonus/DefaultTicketsBonus';
import TicketPortion from './components/TicketPortion/TicketPortion';

interface Props {
  isFirst: boolean;
  amount: number;
  bonus: number;
  bonusFormatted: JSX.Element | number;
  formattedAmount: JSX.Element;
  isSingleTicketInSet: boolean;
}

const TournamentTickets: React.FC<Props> = ({
  isFirst,
  bonus,
  amount,
  bonusFormatted,
  isSingleTicketInSet,
  formattedAmount
}) => {
  const {
    data: { preCashinInfo }
  } = useWizardContext();

  const { fppReleasePortion, ticketReleasePortion } = preCashinInfo as PreCashinInfo;

  if (fppReleasePortion && ticketReleasePortion < bonus) {
    return (
      <TicketPortion
        amount={amount}
        isFirst={isFirst}
        bonusFormatted={bonusFormatted}
        formattedAmount={formattedAmount}
        isSingleTicketInSet={isSingleTicketInSet}
      />
    );
  }

  return (
    <DefaultTicketsBonus
      isSingleTicketInSet={isSingleTicketInSet}
      bonus={bonus}
      bonusFormatted={bonusFormatted}
      formattedAmount={formattedAmount}
      isFirst={isFirst}
    />
  );
};

export default TournamentTickets;
